import { createSlice } from '@reduxjs/toolkit'

export const pageLoadSlice = createSlice({
  name: 'pageLoad',
  initialState: {
    // 紀錄進入網站第一個頁面的初始化是否已執行，
    // 該初始化只會在使用者資料準備好後執行
    authReadyInitialized: false,

    // 儲存加密後的user id，用於傳送firebase event
    encryptedUserId: {
      value: '',
      isReady: false,
    },

    // 儲存加密後的手機號碼，用於防止重複呼叫加密API
    encryptedPhone: {
      value: '',
      isReady: false,
    },

    // 自建單參數設定
    selfConstructParamsInitialized: false,

    // 判斷navbar點擊狀態
    navbarClicked: false,
  },
  reducers: {
    setPageLoadAuthReadyInitialized: (state, action) => {
      state.authReadyInitialized = action.payload
    },
    setEncryptedUserId: (state, action) => {
      state.encryptedUserId.value = action.payload
      state.encryptedUserId.isReady = true
    },
    setEncryptedUserIdReady: (state, action) => {
      state.encryptedUserId.isReady = action.payload
    },
    setEncryptedPhone: (state, action) => {
      state.encryptedPhone.value = action.payload
      state.encryptedPhone.isReady = true
    },
    setEncryptedPhoneReady: (state, action) => {
      state.encryptedPhone.isReady = action.payload
    },
    setSelfConstructParamsInitialized: (state, action) => {
      state.selfConstructParamsInitialized = action.payload
    },
    setNavbarClicked: (state, action) => {
      state.navbarClicked = action.payload
    },
  },
})

export const selectPageLoad = (state) => state.pageLoad
export const selectEnctyptedUserId = (state) => state.pageLoad.encryptedUserId
export const selectNavbarClicked = (state) => state.pageLoad.navbarClicked

export const {
  setPageLoadAuthReadyInitialized,
  setEncryptedUserId,
  setEncryptedUserIdReady,
  setEncryptedPhone,
  setEncryptedPhoneReady,
  setSelfConstructParamsInitialized,
  setNavbarClicked,
} = pageLoadSlice.actions

export default pageLoadSlice.reducer
